import React from "react";

import {Typography} from "@mui/material";
import {SxProps} from "@mui/material/styles";
import {typografNode} from "../../utils/typograf";

type List1Props = {
    children: React.ReactNode;
    className?: string;
    sx?: SxProps;
};

function List1({children, className, sx}: List1Props) {
    return (
        <Typography sx={[{
            fontWeight: '400',
            fontFamily: 'Roboto, sans-serif',
            letterSpacing: 0,
            '@media screen and (min-width: 1400px)': {
                fontSize: '18px',
                lineHeight: 1.6,
            },
            '@media screen and (min-width: 1200px) and (max-width: 1399px)': {
                fontSize: '18px',
                lineHeight: 1.6,
            },
            '@media screen and (min-width: 992px) and (max-width: 1199px)': {
                fontSize: '16px',
                lineHeight: 1.63,
            },
            '@media screen and (min-width: 768px) and (max-width: 1199px)': {
                fontSize: '16px',
                lineHeight: 1.63,
                overflowWrap: 'normal',
            },
            '@media screen and (min-width: 576px) and (max-width: 767px)': {
                fontSize: '14px',
                lineHeight: 1.6,
            },
            '@media screen and (max-width: 575px)': {
                fontSize: '14px',
                lineHeight: 1.6,
            },
        }, ...(Array.isArray(sx) ? sx : [sx ?? false])]} className={className}>
            {typografNode(children)}
        </Typography>
    );
}

export default List1
